import React, { useState, useEffect } from "react";
import Spinner from "../Spinner";
import "../../assets/css/Modal.css";
export default function AddStudyModal({ open, onClose, onSubmit, initial = null, title = "Add Study", submitLabel = "Save" }) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [createdAt, setCreatedAt] = useState("");
  const [startDate, setStartDate] = useState("");
  const [closeDate, setCloseDate] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const getCurrentDateString = () => {
    const now = new Date();
    const yyyy = now.getFullYear();
    const mm = String(now.getMonth() + 1).padStart(2, "0");
    const dd = String(now.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  useEffect(() => {
    if (open) {
      const isNewStudy = !initial?.id;
      const currentDate = getCurrentDateString();
      
      setName(initial?.name || "");
      setDescription(initial?.description || "");
      
      const toDateInput = (v, useCurrentIfEmpty = false) => {
        if (useCurrentIfEmpty && !v) return currentDate;
        if (!v) return "";
        const d = new Date(v);
        if (isNaN(d)) return String(v);
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, "0");
        const dd = String(d.getDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
      };
      
      setCreatedAt(toDateInput(initial?.createdAt || initial?.created_at, isNewStudy));
      setStartDate(toDateInput(initial?.startDate || initial?.start_date, isNewStudy));
      setCloseDate(toDateInput(initial?.closeDate || initial?.close_date));
      setSubmitting(false);
      setError("");
    }
  }, [open, initial]);

  if (!open) return null;

  const reset = () => {
    setName(initial?.name || "");
    setDescription(initial?.description || "");
    setCreatedAt(initial?.createdAt || initial?.created_at || "");
    setStartDate(initial?.startDate || initial?.start_date || "");
    setCloseDate(initial?.closeDate || initial?.close_date || "");
    setSubmitting(false);
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!name.trim()) {
      setError("Name is required");
      return;
    }
    try {
      setSubmitting(true);
      const formData = {
        name,
        description: description || undefined,
        createdAt: createdAt || undefined,
        startDate: startDate || undefined,
        closeDate: closeDate || undefined
      };
      await onSubmit(formData);
      reset();
      onClose?.();
    } catch (err) {
      console.error("Error submitting form:", err);
      setError(err.response?.data?.message || "Failed to save study");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="modal-backdrop" role="dialog" aria-modal="true" aria-labelledby="addStudyTitle">
      <div className="modal">
        <div className="modal-header">
          <h3 id="addStudyTitle" style={{ margin: 0 }}>{title}</h3>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            {error && (
              <div className="error-message">{error}</div>
            )}
            <div className="form-row">
              <label>Name *</label>
              <input
                className="input"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
            <div className="form-row">
              <label>Description</label>
              <textarea
                className="input"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                rows={3}
                style={{ resize: "vertical" }}
              />
            </div>
            <div className="form-row">
              <label>Start Date</label>
              <input
                className="input"
                type="text"
                value={createdAt}
                // Date should not be editable
                // onChange={(e) => setCreatedAt(e.target.value)}
                readOnly
                disabled 
              />
            </div>
            {/* <div className="form-grid-2">
              <div className="form-row">
                <label>Start Date</label>
                <input
                  className="input"
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </div>
              <div className="form-row">
                <label>Close Date</label>
                <input
                  className="input"
                  type="date"
                  value={closeDate}
                  onChange={(e) => setCloseDate(e.target.value)}
                />
              </div>
            </div> */}
          </div>
          <div className="modal-actions">
            <button type="button" className="button secondary" onClick={() => { reset(); onClose?.(); }}>
              Cancel
            </button>
            <button type="submit" className="button primary" disabled={submitting}>
              {submitting ? (
                <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                  <Spinner inline size={16} thickness={2} label="Saving" />
                  Saving...
                </span>
              ) : (
                submitLabel
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
